import gql from 'graphql-tag';
import flightLocation from './flightLocation.fragment.graphql.js';

export default gql`
  ${flightLocation}

  query initialData($isBooking: Boolean) {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          maxMarketsToDisplay
          showFlightAndHotelCheckbox
          flightAndHotelDefaultChecked
          showFlightAndCarCheckbox
          flightAndCarDefaultChecked
          minPartyAdults
          maxPartyAdults
          defaultAdultsCount
          minPartyNonAdults
          maxPartyNonAdults
          defaultNonAdultsCount
          isSunCountryEnabled
          sunCountryDeeplink
        }

        translations(language: enUS) {
          flightSearchForm {
            #Trip type
            tripTypeA11yDescription
            roundTripLabel
            oneWayLabel

            # Airports
            departureAirportLabel
            departureAirportPlaceholder
            departureAirportEmptyLabel
            destinationAirportLabel
            destinationAirportPlaceholder
            destinationAirportEmptyLabel

            # Date picker
            departureDateLabel
            departureDatePlaceholder
            returnDateLabel
            returnDatePlaceholder
            roundTripDiscountIncentiveText
            allegiantOperatedFlightLegendHTML
            sunCountryOperatedFlightLegendHTML
            sunCountryInfoLegendTextHTML

            # Travelers
            travelersLabel
            travelersA11yDescription

            adultsLabel
            adultsLabelSingular
            adultsDescription
            adultsA11yDescription
            adultsDescriptionInternational
            adultsA11yDescriptionInternational

            childrenLabel
            childrenLabelSingular
            childrenDescription
            childrenA11yDescription
            childrenDescriptionInternational
            childrenA11yDescriptionInternational

            childrenInfoModalParagraph1
            childrenInfoModalParagraph2
            childrenInfoModalParagraph3
            additionalInfoModalLinkText
            childrenInfoModalParagraph1International
            childrenInfoModalParagraph2International
            childrenInfoModalParagraph3International

            infantsInSeatLabel
            infantsInSeatSingularLabel
            infantsInSeatDescription
            infantsInSeatA11yDescription
            infantsInSeatInfoModalText

            infantsInLapLabel
            infantsInLapSingularLabel
            infantsInLapDescription
            infantsInLapA11yDescription
            infantsInLapInfoModalText

            seatedTravelersLabel
            inLapTravelersLabel

            # Bundled options
            flightAndHotelLabel
            flightAndCarLabel

            # Form
            searchButtonLabel

            # Validation
            emptyOriginValidation
            emptyDestinationValidation
            emptyDepartureDateValidation
            emptyReturnDateValidation

            # Optional Services
            optionalServicesAndFeesLink
            changedBagFeesPolicyLink
            chartersLink
          }
        }

        images(section: "sunCountryIntegrationImage") {
          id
          path
          alt
          title
        }
      }
    }

    flightLocations(isBooking: $isBooking) {
      ...FlightLocationFragment
    }
  }
`;
